import { Tooltip } from "antd";

export const BREAKPOINTS = {
  xs: 0, // Extra Small (less than 576px)
  sm: 576, // Small (equal to or greater than 576px)
  md: 768, // Medium (equal to or greater than 768px)
  lg: 992, // Large (equal to or greater than 992px)
  xl: 1200, // Extra Large (equal to or greater than 1200px)
};

export const VIBRANT_COLORS = [
  { name: "Electric Blue", code: "#7DF9FF" },
  { name: "Neon Green", code: "#39FF14" },
  { name: "Fuchsia", code: "#FF00FF" },
  { name: "Electric Yellow", code: "#FFFF00" },
  { name: "Electric Orange", code: "#FFA500" },
  { name: "Electric Purple", code: "#BF00FF" },
  { name: "Cyan", code: "#00FFFF" },
  { name: "Magenta", code: "#FF00FF" },
  { name: "Hot Pink", code: "#FF69B4" },
  { name: "Turquoise", code: "#40E0D0" },
];

export const HOME_DASHBOARD_METRICS_DESCRIPTION = {
  faturamento_total:
    "Faturamento total da loja durante o período de análise. São consideradas apenas as vendas presenciais.",
  receita_tempo_permanencia:
    "Receita calculada pelo tempo de permanência em horas nas zonas da loja.",
  entrada_total_pessoas: "Quantidade total de pessoas que entraram na loja.",
  conversao:
    "Métrica que relaciona a quantidade de vendas efetuadas pela quantidade de pessoas que entram na loja.",
};

export const FLOW_DETECTIONS_METRICS = [
  {
    key: "total_entries",
    title: "Entrada Total de Pessoas na Loja",
    description:
      "Quantidade total de pessoas que entraram na loja no dia e período selecionados.",
    suffix: "",
  },
  {
    key: "occupied_percent",
    title: "Porcentagem de ocupação da loja",
    description:
      "Porcentagem do tempo total em que a loja esteve ocupada. É calculada pela contagem dos minutos em que a loja esteve ocupada dividida pela contagem total de minutos do período selecionado. Essa métrica não é afetada pelos filtros de zonas e coleção, apenas pelos filtros de período e data",
    suffix: "%",
  },
  {
    key: "max_people",
    title: "Pico de pessoas na loja",
    description:
      "Número máximo (pico) simultâneo de pessoas, considerando todas as zonas da loja. Essa métrica não é afetada pelos filtros de zonas e coleção, apenas pelos filtros de período e data.",
    suffix: "",
  },
  {
    key: "avg_occupied_time",
    title: "Tempo médio de permanência por zona",
    description:
      "Tempo de permanência acumulado de todas as zonas selecionadas dividido pela quantidade de zonas distintas.",
    suffix: "min",
  },
];

export const REVENUE_KPIS_METRICS = [
  {
    key: "faturamento_total",
    title: "Faturamento total",
    description:
      "Faturamento total da loja selecionada durante o período de análise. São consideradas apenas as vendas presenciais.",
    suffix: "",
    formatter: "currency",
  },
  {
    key: "ticket_medio",
    title: "Ticket médio",
    description:
      "Valor médio faturado por venda. É calculado pelo faturamento total dividido pela quantidade de vendas.",
    suffix: "",
    formatter: "currency",
  },
  {
    key: "valor_medio_faturado_item",
    title: "Faturamento por item",
    description: "Valor da média de cada item vendido na Loja.",
    suffix: "",
    formatter: "currency",
  },
  {
    key: "quantidade_de_vendas",
    title: "Quantidade de vendas",
    description:
      "Quantidade total de vendas presenciais da loja selecionada no intervalo de datas filtrado.",
    suffix: "",
  },
  {
    key: "conversao",
    title: "Conversão",
    description:
      "Métrica que relaciona a quantidade de vendas efetuadas pela quantidade de pessoas que entram na loja.",
    suffix: "%",
  },
  // {
  //   key: "receita_hora",
  //   title: "Receita por hora",
  //   description:
  //     "Receita total da loja selecionada dividida pelo número de horas do período selecionado.",
  //   suffix: "",
  //   formatter: "currency",
  // },
];

export const PEAK_HOURS_METRICS = [
  {
    key: "occupied_time_accum",
    title: "Tempo de permanência acumulado",
    description:
      "Tempo de permanência acumulado de todas as zonas selecionadas dividido pela quantidade de zonas distintas.",
    prefix: "",
    suffix: "min",
  },
  {
    key: "peak_people",
    title: "Pico de pessoas",
    description:
      "Número máximo (pico) simultâneo de pessoas, considerando todas as zonas da loja. Essa métrica não é afetada pelos filtros de zonas e coleção, apenas pelos filtros de período e data.",
    prefix: "",
    suffix: "",
  },
  {
    key: "occupancy_rate",
    title: "Porcentagem de ocupação",
    description:
      "Porcentagem do tempo total em que a loja esteve ocupada. É calculada pela contagem dos minutos em que a loja esteve ocupada dividida pela contagem total de minutos do período selecionado. Essa métrica não é afetada pelos filtros de zonas e coleção, apenas pelos filtros de período e data",
    prefix: "",
    suffix: "%",
  },
];

export const FLOW_DETECTIONS_TABLE_COLUMNS = [
  {
    title: "Descrição",
    dataIndex: "description",
    key: "description",
    width: "auto",
    ellipsis: true,
  },
  {
    title: "Permanência",
    dataIndex: "permanence",
    key: "permanencia",
    width: "auto",
    ellipsis: false,
    defaultSortOrder: "descend",
    sorter: (a, b) =>
      parseFloat(a.permanence.slice(0, -3)) -
      parseFloat(b.permanence.slice(0, -3)),
  },
  {
    title: (
      <Tooltip title="Porcentagem do tempo em que a zona esteve com pelo menos uma pessoa presente durante o primeiro e último registro de permanência.">
        Ocupação
      </Tooltip>
    ),
    dataIndex: "ocupation",
    key: "ocupacao",
    width: "auto",
    ellipsis: true,
  },
  {
    title: "Pico",
    dataIndex: "peak",
    key: "pico",
    width: "auto",
    ellipsis: true,
  },
];

export const PEAK_HOURS_TABLE_COLUMNS = [
  {
    title: "Horário",
    dataIndex: "hour",
    key: "hour",
    width: "auto",
    ellipsis: true,
  },
  {
    title: "Permanência",
    dataIndex: "permanence",
    key: "permanence",
    width: "auto",
    ellipsis: true,
  },
  {
    title: "Ocupação",
    dataIndex: "occupation",
    key: "occupation",
    width: "auto",
    ellipsis: false,
  },
  {
    title: "Pico",
    dataIndex: "peak",
    key: "peak",
    width: "auto",
    ellipsis: true,
  },
];

export const REVENUE_KPIS_METRICS_DESCRIPTION = {
  faturamento_total:
    "Faturamento total da loja selecionada durante o período de análise. São consideradas apenas as vendas presenciais.",
  ticket_medio: "Valor médio faturado por venda.",
  faturamento_item: "Valor da média de cada item vendido na Loja.",
  receita_tempo_permanencia:
    "Receita calculada pelo tempo de permanência nas zonas filtradas.",
  conversao:
    "Métrica que relaciona a quantidade de vendas efetuadas pela quantidade de pessoas que entram na loja.",
  quantidade_vendas:
    "Quantidade total de vendas presenciais da loja selecionada no intervalo de datas filtrado.",
};

export const MENU_ITEMS_DESCRIPTION = {
  flow_detections: "Métricas do fluxo geral de pessoas na loja",
  collections_change:
    "Métricas de aumento/diminuição do fluxo de pessoas após eventos",
  peak_hours: "Métricas sobre horários de maior movimento",
  events_manager: "Criação/edição de coleções e eventos",
  zones_manager: "Criação/edição de zonas e câmeras",
  revenue: "Métricas sobre o faturamento da loja",
  opening_hours: "Gerencie os horários de funcionamento da loja",
  control_panel: "Gerencie o quadro de lojas e permissões de usuários",
};

export const HOME_DASHBOARD_ZONES_CARDS_KPIS = [
  {
    title: "Faturamento",
    key: "first_zones",
    group: "revenue",
  },
  {
    title: "Faturamento",
    key: "last_zones",
    group: "revenue",
  },
  {
    title: "Faturamento por hora",
    key: "first_zones",
    group: "revenue_per_hour",
  },
  {
    title: "Faturamento por hora",
    key: "last_zones",
    group: "revenue_per_hour",
  },
  {
    title: "Ocupação",
    key: "first_zones",
    group: "occupation",
  },
  {
    title: "Ocupação",
    key: "last_zones",
    group: "occupation",
  },
];

export const HOME_DASHBOARD_COLLECTIONS_CARDS_KPIS = [
  {
    title: "Faturamento",
    key: "first_collections",
    group: "revenue",
  },
  {
    title: "Faturamento",
    key: "last_collections",
    group: "revenue",
  },
  {
    title: "Faturamento por hora",
    key: "first_collections",
    group: "revenue_per_hour",
  },
  {
    title: "Faturamento por hora",
    key: "last_collections",
    group: "revenue_per_hour",
  },
  {
    title: "Visibilidade",
    key: "first_collections",
    group: "occupation",
  },
  {
    title: "Visibilidade",
    key: "last_collections",
    group: "occupation",
  },
];

export const HOME_DASHBOARD_CARDS = [
  {
    title: "Total Faturado",
    description: HOME_DASHBOARD_METRICS_DESCRIPTION["faturamento_total"],
    key: "faturamento_total",
    tagValue: "variacao_faturamento_total",
    formatter: "currency",
  },
  {
    title: "Faturamento por hora",
    description:
      HOME_DASHBOARD_METRICS_DESCRIPTION["receita_tempo_permanencia"],
    key: "receita_hora",
    tagValue: "variacao_receita_hora",
    formatter: "currency",
  },
  {
    title: "Entradas",
    description: HOME_DASHBOARD_METRICS_DESCRIPTION["entrada_total_pessoas"],
    tagValue: "variacao_entradas_total",
    key: "entradas_total",
  },
  {
    title: "Conversão",
    description: HOME_DASHBOARD_METRICS_DESCRIPTION["conversao"],
    key: "conversao",
    tagValue: "variacao_conversao",
    suffix: "%",
  },
];
